<template>
  <div class="app-wrapper">
    <my-header></my-header>
    <div class="mainBox">
      <nav-menu></nav-menu>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import MyHeader from "./components/myHeader.vue";
import NavMenu from "./components/navMenu.vue";
import AppMain from "./components/appMain.vue"

export default {
  components: {
    NavMenu,
    MyHeader,
    AppMain,
  },
  methods: {
    
  }
};
</script>

<style lang="less" scoped>
.app-wrapper {
  width:100vw;
  height: auto;
  background: #EFEFEF;
  .mainBox{
    height: 85%;
    margin: 20px auto;
    width: 13.44rem;
    margin: 0.2rem auto;
    display: flex;
  }
}

</style>
